"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DarkTheme = void 0;

var _creator = _interopRequireDefault(require("./creator.js"));

var _darkThemePrimitives = require("./dark-theme-primitives.js");

var _darkThemeColors = _interopRequireDefault(require("./dark-theme-colors.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DarkTheme = (0, _creator.default)(_objectSpread({}, _darkThemePrimitives.primitives), _objectSpread({
  name: 'dark-theme'
}, _darkThemeColors.default));
exports.DarkTheme = DarkTheme;